import React from 'react';
import { object, func } from 'prop-types';
import RelayQueryLookupRenderer from 'relay-query-lookup-renderer';
import Footer from '../Footer/Footer';

const FooterRenderer = props => {
    const { environment, initialVariables, query, intlVariables } = props;
    return (
        <RelayQueryLookupRenderer
            lookup
            environment={environment}
            query={query}
            variables={initialVariables}
            render={({ error, props: rendererProps }) => {
                // eslint-disable-line react/display-name, react/prop-types
                if (error) {
                    return null;
                } else if (rendererProps) {
                    return <Footer {...rendererProps} intlVariables={intlVariables} />;
                } else {
                    return null;
                }
            }}
        />
    );
};

FooterRenderer.propTypes = {
    environment: object,
    initialVariables: object,
    query: func,
    intlVariables: object,
};

export default FooterRenderer;
